import React from "react";
import { Input, Tooltip } from 'antd';

const SearchBox = ({ styleName, placeholder, onChange, onKeyDown, onSearch, value }) => {

  return (
    <div style={{ borderRadius: '12px', position: 'relative' }} className={`gx-search-bar ${styleName}`}>
      <div className="gx-form-group" style={{ position: 'relative' }}>
        <Tooltip
          mouseEnterDelay={1}
          placement="bottom"
          title="Search by job num, part of property address, invoice number, quote number, client reference"
        >
          <Input
            style={{
              display: 'inline-flex',
              paddingRight: '40px'
            }}
            allowClear={true}
            className="ant-input input-search custom-search-input"
            type="search"
            placeholder={placeholder}
            onChange={onChange}
            onKeyDown={onKeyDown}
            value={value}
          />
        </Tooltip>
        <span
          style={{
            position: 'absolute',
            right: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            zIndex: '99'
          }}
          className="gx-search-icon-new gx-pointer"
        >
          <i className="icon icon-search" onClick={onSearch} />
        </span>
      </div>
    </div>
  )
};
export default SearchBox;

SearchBox.defaultProps = {
  styleName: "",
  value: "",
};
